import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MaskedLine, Overline } from "@/components/Reveal";
import { tr } from "@/i18n";

export default function PageHero({ overline, title, italic, image, children }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);

  return (
    <section ref={ref} className="relative min-h-[62vh] flex items-end overflow-hidden grain">
      {image && (
        <motion.div style={{ y }} className="absolute inset-0 -bottom-32">
          <img src={image} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/60 to-ink/30" />
        </motion.div>
      )}
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 pb-20 pt-48 w-full">
        <Overline className="mb-6">{tr(overline)}</Overline>
        <h1 className="font-serif font-light text-5xl sm:text-6xl md:text-7xl leading-[1.02] tracking-tight text-white max-w-4xl">
          <MaskedLine delay={0.15}>{tr(title)}</MaskedLine>
          {italic && (
            <MaskedLine delay={0.3}>
              <em className="gold-shimmer not-italic font-serif italic">{tr(italic)}</em>
            </MaskedLine>
          )}
        </h1>
        {children && <div className="mt-8 max-w-xl text-white/60 font-light leading-relaxed">{children}</div>}
      </div>
    </section>
  );
}
